<script setup lang="ts">
import { onMounted, ref } from 'vue';
import ImportantTerms from '@/components/ImportantTerms.vue';
import UserLoginModalCircus from '@/components/UserLoginModalCircus.vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthUser } from '@/helpers/globals';
import { useBrowserStorage } from '@kp/geofy-vuejs-lib/tools/browser_local_storage.js';
import KpModal from '@kp/geofy-vuejs-lib/tg-system/components/KpModal.vue';

const router = useRouter();
const route = useRoute();
const loading = ref(false);
const showLoginCircus = ref(false);
const showFidentityError = ref(false);

onMounted(() => {
    if (route.query.fidentityError) {
        showFidentityError.value = true;
    }
});

const user = useAuthUser();

async function onNewGeschaeftClick() {
    const { getStorageValue } = useBrowserStorage('eplan');
    const svDate = getStorageValue('ignoreLot2Warning');
    let ignore = false;
    if (svDate?.length > 0) {
        const date = new Date(svDate);
        const daysDiff = new Date().getDate() - date.getDate();
        ignore = daysDiff <= 30;
    }

    // lot2 vorhanden -> zum geschaeft
    if (user?.has_username_passkey) {
        router.push({ name: 'planungsgeschaefte-create' });
        return;
    }

    // nur lot1 aber lass mich in ruhe -> zum geschaeft
    if (user && ignore) {
        router.push({ name: 'planungsgeschaefte-create' });
        return;
    }

    // nicht angem
    if (!user || !ignore) {
        showLoginCircus.value = false;
        showLoginCircus.value = true;
        return;
    }

    /*if (!user) {
        // redirect to login if user is not yet logged in:
        const redirectUrl = appUrl('/planungsgeschaefte/new');
        emitGlobalEvent('login', redirectUrl);
        return;
    }
    router.push({ name: 'planungsgeschaefte-create' });*/
}
</script>
<template>
    <div class="cta-grid">
        <div>
            <h2 class="ktg-title-02 mb-2_5rem">{{ $t('overview') }}</h2>
            <p class="ktg-body-lead mb-5rem" v-html="$t('geschaeft_overview_info_text')"></p>
        </div>

        <div>
            <h4 class="ktg-title-04 mb-2_5rem">{{ $t('dienstleistungen') }}</h4>
            <h5 class="ktg-subtitle-02 mb-1_5rem">{{ $t('geschaefte') }}</h5>
            <ktg-action-list class="ktg-box-margin-left mb-5rem">
                <ktg-action-item
                    href="href"
                    :link-text="loading ? $t('bitte_warten') : $t('starten')"
                    :disabled="loading"
                    @click.prevent="onNewGeschaeftClick"
                >
                    {{ $t('create_new_geschaeft') }}
                </ktg-action-item>
                <RouterLink :to="{ name: 'planungsgeschaefte-my-geschaefte' }" custom v-slot="{ href }">
                    <ktg-action-item :href="href" :link-text="$t('starten')">
                        {{ $t('edit_existing_geschaeft') }}
                    </ktg-action-item>
                </RouterLink>
            </ktg-action-list>
            <ImportantTerms
                :path="['geschaefte', 'overview_faq']"
                :title="$t('fragen_und_antworten')"
                size="small"
            ></ImportantTerms>
        </div>
    </div>
    <KpModal v-model="showFidentityError">
        {{ $t('err_msg_fidentity_error') }}
    </KpModal>
    <UserLoginModalCircus :user="useAuthUser()" v-model="showLoginCircus" />
</template>

<style scoped></style>
